import React from 'react';
import styled from 'styled-components';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { BaseComponent } from '../BaseComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faSearch } from '@fortawesome/free-solid-svg-icons';

const PAGE_COLOR = '#2c3038';

const PageLink = styled.button`
  white-space: nowrap;
  color: ${props => (!props.active ? '#FFFFFF' : `${props.color}`)};
  font-size: 14px;
  font-weight: bold;
  background-color: ${props => (!props.active ? `${props.color}` : '#FFFFFF')};
  border-radius: 50%;
  margin: 0 4px;
  border: ${props => (!props.active ? '1px solid #FFFFFF' : `1px solid ${props.color}`)};
  min-width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PaginationContainer = styled.div`
  width: 100%;
  height: 50px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${props => (props.innerWidth <= 768 ? '100px' : '')};
`;

const GotoInput = styled.input`
  margin-left: 12px;
  width: 75px;
  height: 30px;
  padding: 8px;
  border-radius: 15px;
`;

const STATE = {
  goToPage: '',
};

class PaginationComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  gotoPage = () => {
    this.props.selectPage(this.state.goToPage - 1);
  };

  render() {
    const { offset, limit, itemsCount } = this.props.paginator;
    const canPreviousPage = offset > 0;
    const pagesCount = itemsCount ? Math.ceil(itemsCount / limit) : 0;
    const canNextPage = offset < itemsCount - limit;
    const page = Math.floor(offset / limit);
    const pagesLinks = () => {
      let result = [];
      if (pagesCount <= 7) {
        for (let i = 1; i <= pagesCount; i++) {
          result.push(i);
        }
      } else {
        if (page < 5) {
          result.push(1, 2, 3, 4, 5, '...', pagesCount);
        } else if (page > pagesCount - 5) {
          result.push(1, '...');
          for (let i = pagesCount - 4; i <= pagesCount; i++) result.push(i);
        } else {
          result.push(1, '...');
          for (let i = page; i <= page + 2; i++) {
            result.push(i);
          }
          result.push('...', pagesCount);
        }
      }
      return result;
    };

    return (
      <PaginationContainer innerWidth={window.innerWidth}>
        <PageLink color={PAGE_COLOR} onClick={() => this.props.selectPage(page - 1)} disabled={!canPreviousPage}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </PageLink>

        {itemsCount &&
          pagesLinks()?.map(item =>
            item === '...' ? (
              '...'
            ) : (
              <PageLink
                key={`page${item}`}
                color={PAGE_COLOR}
                onClick={() => this.props.selectPage(item - 1)}
                active={item === page + 1}
              >
                {item}
              </PageLink>
            ),
          )}

        <PageLink color={PAGE_COLOR} onClick={() => this.props.selectPage(page + 1)} disabled={!canNextPage}>
          <FontAwesomeIcon icon={faChevronRight} />
        </PageLink>

        <GotoInput
          type="number"
          min="1"
          max={Math.ceil(this.props.paginator.itemsCount / this.props.paginator.limit)}
          value={this.state.goToPage}
          onChange={e => this.setState({ goToPage: +e.target.value })}
        />
        <PageLink color={PAGE_COLOR} onClick={this.gotoPage}>
          <FontAwesomeIcon icon={faSearch} />
        </PageLink>
      </PaginationContainer>
    );
  }
}

export const Pagination = compose(withRouter)(PaginationComp);
